import { EmbeddedSelectionContext } from "@intelligems/ig-types";
import { createAsyncThunk } from "@src/store/createAsyncThunk";
import { selectElements as selectElementsBasicMod } from "@src/store/slices/experienceBuilder/basicMod/thunks/selectElements";
import { getModificationsLockStatus } from "@src/store/slices/experienceBuilder/common/selectors/getModificationsLockStatus";
import { getVariationMods } from "@src/store/slices/experienceBuilder/common/selectors/getVariationMods";
import { cancelDraft } from "@src/store/slices/experienceBuilder/common/thunks/cancelDraft";
import { editMod } from "@src/store/slices/experienceBuilder/common/thunks/editMod";

export const selectElements = createAsyncThunk<void, EmbeddedSelectionContext>(
  "experienceBuilder/common/selectElements",
  async (context, { dispatch, getState }) => {
    if (getModificationsLockStatus(getState()) === "locked") return;

    if (context.onsiteEditId) {
      const confirmed = await dispatch(cancelDraft()).unwrap();
      if (!confirmed) return;
      const mod = getVariationMods(getState()).find(
        (m) => m.id === context.onsiteEditId
      );
      if (mod) {
        void dispatch(editMod(mod));
        return;
      }
    }

    await dispatch(selectElementsBasicMod(context));
  }
);
